import { css } from "@emotion/css";

import { Group } from "@/modules/groups/types";
import { Deadline } from "@/modules/theme/components/Deadline/Deadline";
import { LabelAdornment } from "@/modules/theme/components/Label/LabelAdornment";
import { PointsLabel } from "@/modules/theme/components/PointsLabel";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

type TaskLayoutDetailsProps = {
  deadline?: string | null;
  points: number;
  groups?: Group[];
};

export const TaskLayoutDetails: React.FC<TaskLayoutDetailsProps> = ({
  deadline,
  points,
  groups,
}) => {
  const classes = createTaskLayoutDetailsStyles(useTheme());
  return (
    <div className={classes.root}>
      {deadline ? <Deadline variant="dark">{deadline}</Deadline> : <div />}
      <div className={classes.labels}>
        <PointsLabel points={points} className={classes.label} />
        {groups?.map(({ colorHex, name }) => (
          <LabelAdornment
            key={name}
            text={name}
            color={colorHex}
            className={classes.label}
          />
        ))}
      </div>
    </div>
  );
};

function createTaskLayoutDetailsStyles({ spacing }: Theme) {
  return {
    root: css({
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexBasis: "100%",
    }),
    labels: css({
      display: "flex",
      flexWrap: "wrap",
    }),
    label: css({
      margin: spacing([0.5, 0.5, 0, 0]),
    }),
  };
}
